import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["video", "icon", "label"]

    connect() {
        // Default to muted (autoplay-safe)
        if (this.hasVideoTarget) {
            this.videoTarget.muted = true
            this._syncUi()
        }
    }

    async toggle(event) {
        // Make sure this counts as the user gesture
        event?.preventDefault?.()
        event?.stopPropagation?.()

        if (!this.hasVideoTarget) return

        const v = this.videoTarget
        v.muted = !v.muted

        // If turning sound on, force play inside the same gesture
        if (!v.muted) {
            try {
                await v.play()
            } catch (_) {
                // If the browser still blocks, next gesture will succeed anyway
            }
        }
        this._syncUi()
    }

    _syncUi() {
        if (!this.hasVideoTarget) return
        const on = !this.videoTarget.muted

        if (this.hasIconTarget) {
          this.iconTarget.className = on ? "bi bi-volume-up-fill" : "bi bi-volume-mute-fill"
        }
        if (this.hasLabelTarget) this.labelTarget.textContent = on ? "Sound on" : "Sound off"
    }
}